export const messages = {
  en: {
    resourceEnterManage: {
      title: 'Resource Entry Management',
      orderNumber: 'Order Number',
      itemName: 'Item Name',
      itemCode: 'Item Code',
      itemStock: 'Item Stock',
      applyQuantity: 'Apply Quantity',
      purchaseQuantity: 'Purchase Quantity',
      purchasePrice: 'Purchase Price',
      remark: 'Remark',
      submit: 'Submit',
      purchaseQuantityRequired: 'Purchase quantity is required',
      priceRequired: 'Price is required',
      processSuccess: 'Process successful',
      processFailed: 'Process failed'
    }
  },
  zh: {
    resourceEnterManage: {
      title: '资源入库管理',
      orderNumber: '单号',
      itemName: '物品名称',
      itemCode: '物品编码',
      itemStock: '物品库存',
      applyQuantity: '申请数量',
      purchaseQuantity: '采购数量',
      purchasePrice: '采购单价',
      remark: '备注',
      submit: '提交',
      purchaseQuantityRequired: '采购数量未填写',
      priceRequired: '单价未填写',
      processSuccess: '处理成功',
      processFailed: '处理失败'
    }
  }
}